import { IconPaths, ModalSize } from '../../../../../../../_metronic/helpers'
import { Button, useModal } from '../../../../../../components'
import { ImportacaoModalForm } from '../../../form-modal/ImportacaoModalForm'

const ImportacaoListToolbar = () => {
  const { showModal } = useModal()

  const openImportAtendimentos = () => {
    showModal({ title: 'Importação', content: <ImportacaoModalForm />, size: ModalSize.Medium })
  }

  return (
    <Button className='btn-primary' onClick={openImportAtendimentos} icon={IconPaths.Add}>
      Importar
    </Button>
  )
}

export { ImportacaoListToolbar }
